import { Controller } from "@hotwired/stimulus"

// top-nav--search-hotkey — opens the global search modal on Cmd+K (macOS)
// or Ctrl+K (elsewhere) from anywhere in the app.
//
// There is no click to simulate and no global JS state to reach, so this
// separate controller talks to the modal through a `core--modal` Stimulus
// outlet and calls its public `open()` action — the idiomatic way to drive
// one controller from another.
//
// Guards:
//   - ignores the keystroke when focus is already in a text input, a
//     textarea, or a contenteditable element, so it never hijacks typing;
//   - preventDefault()s only when it actually opens the modal, leaving the
//     browser's own Ctrl/Cmd+K binding intact in the ignored cases.
export default class extends Controller {
  static outlets = ["core--modal"]

  onKeydown(event) {
    if (event.key !== "k" && event.key !== "K") return
    if (!(event.metaKey || event.ctrlKey)) return
    if (event.altKey) return
    if (this.isEditingContext(event.target)) return
    if (!this.hasCoreModalOutlet) return

    event.preventDefault()
    this.coreModalOutlet.open()
  }

  isEditingContext(element) {
    if (!element) return false
    const tag = element.tagName
    return (
      tag === "INPUT" ||
      tag === "TEXTAREA" ||
      tag === "SELECT" ||
      element.isContentEditable === true
    )
  }
}
